<template>
    <v-container fluid style="margin: 60px 10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.AdministracionAplicaciones') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-dialog v-model="postulaciones.dialog" style="margin:0;" width="40%">
          <v-card>
            <v-card-title>
              <v-container>
                <v-row style="margin:0;">
                    <v-col cols="12" align="center" style="margin:0;padding:0;">
                        <v-img contain :src="postulaciones.preview" />
                        <v-btn @click="postulaciones.dialog = false" style="border:2px solid;" outlined x-large class="mt-5">Cerrar</v-btn>
                    </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-dialog>
        <v-row>
          <v-col cols="12" align="center">
                <v-btn @click="eleccion = 'pendientes'" outlined class="ma-2" style="border: 2px solid;">{{ $t('Administracion.Pendientes')}}</v-btn>
                <v-btn @click="eleccion = 'finalizados'" outlined class="ma-2" style="border: 2px solid;">{{ $t('Administracion.Finalizados')}}</v-btn>
            </v-col>
            <v-col cols="12">
              <v-text-field solo v-model="buscar" :label="$t('Busqueda.Buscar')"></v-text-field>
              <v-data-table
              :items="postulaciones.todos"
              :headers="headerPostulaciones"
              :search="buscar"
              >
              <template v-slot:[`item.estado`]="{ item }">
                <v-icon v-if="item.revisado && item.aprobado" color="green">fas fa-check</v-icon>
                <v-icon v-if="item.revisado && !item.aprobado" color="red">fas fa-times</v-icon>
                <v-icon v-if="!item.revisado">far fa-clock</v-icon>
              </template>
              <template v-slot:[`item.acciones`]="{ item }">
                <v-icon class="mx-2" color="black" @click="ver(item)">far fa-eye</v-icon>
              </template>
              </v-data-table>
              <v-dialog v-model="dialog">
                <v-card v-if="i">
                  <v-card-title>
                      <v-row>
                          <v-col cols="12">
                              <v-row>
                                  <v-col cols="10">
                                      <h4>{{ i.nombre }}</h4>
                                  </v-col>
                                  <v-col cols="2">
                                      <v-icon v-if="i.revisado && i.aprobado" color="green">fas fa-check</v-icon>
                                      <v-icon v-if="i.revisado && !i.aprobado" color="red">fas fa-times</v-icon>
                                      <v-icon v-if="!i.revisado">far fa-clock</v-icon>
                                  </v-col>
                                  <v-col cols="12" xs="12" md="6">
                                     <span>{{$t('SubMenus.Idioma')}}: {{$t('Regalo.' + i.idioma)}}</span>
                                  </v-col>
                              </v-row>
                          </v-col>
                          <v-col cols="12">
                              <p class="subtitle-1">{{i.codigo}}</p>
                          </v-col>
                      </v-row>
                  </v-card-title>
                  <v-divider />
                  <v-list dense>
                      <v-list-item>
                          <v-list-item-content>Email:</v-list-item-content>
                          <v-list-item-content class="align-end">{{ i.email }}</v-list-item-content>
                      </v-list-item>
                       <v-list-item>
                          <v-list-item-content>Teléfono:</v-list-item-content>
                          <v-list-item-content class="align-end">{{ i.telefono }}</v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                          <v-list-item-content>Dirección:</v-list-item-content>
                          <v-list-item-content class="align-end">{{ i.direccion }} {{ i.ciudad }} - {{ i.departamento }} - {{ getPaises[i.pais - 1].name}}</v-list-item-content>
                      </v-list-item>
                  </v-list>
                  <v-card-text>
                      <v-divider></v-divider>
                      <v-row>
                          <v-col cols="12">
                              <p class="text-center font-weight-bold">Biografía</p>
                              <p class="px-5" v-if="i.biografiaEs" style="line-height:1.5rem; white-space:pre-wrap;">{{ i.biografiaEs}}</p>
                          </v-col>
                          <v-col cols="12" align="center">
                              <a
                              v-for="(redes, index) in i.redesSociales"
                              :key="index"
                              :href="redes.enlace"
                              target="_blank"
                              style="text-decoration:none;">
                              <v-icon class="mx-3">{{redes.icono}}</v-icon>
                              </a>
                          </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="12">
                              <p class="text-center font-weight-bold">¿Qué visión tienes como artista y/o diseñador en 5-10 y 15 años?</p>
                              <p class="px-5" v-if="i.vision" style="line-height:1.5rem; white-space:pre-wrap;">{{ i.vision}}</p>
                          </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="12">
                              <p class="text-center font-weight-bold">Según tu forma de entender el arte y/o el diseño ¿Cuál sería el camino para llegar a tener una mayor cultura artística global?</p>
                              <p class="px-5" v-if="i.camino" style="line-height:1.5rem; white-space:pre-wrap;">{{ i.camino}}</p>
                          </v-col>
                      </v-row>
                  </v-card-text>
                  <v-card-actions>
                      <v-row style="max-width:-webkit-fill-available!important;">
                          <v-col cols="12">
                          <v-row class="px-2">
                              <v-col cols="12" xs="12" sm="4" v-for="(imagen, index) in i.imagenes" :key="index">
                                  <v-img :src="imagen" contain width="100%" @click="imagenGrande(imagen)"/>
                              </v-col>
                          </v-row>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea solo v-model="comentario" :label="$t('Formularios.ComentarioDelModerador')" :hint="$t('Formularios.ComentarioDelModerador')" />
                          </v-col>
                          <v-col cols="12" align="center">
                              <v-btn @click="dialog = false" style="border:2px solid" outlined x-large class="mx-3">Cerrar</v-btn>
                              <v-btn @click="rechazar(indexElegido)" class="mx-3" style="border:2px solid" x-large outlined :disabled="i.rechazado">{{$t('Administracion.Rechazar')}}</v-btn>
                              <v-btn @click="aprobar(indexElegido)" class="mx-3" color="black white--text" x-large :disabled="i.aprobado">{{$t('Administracion.Aprobar')}}</v-btn>
                          </v-col>
                      </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'AdministracionAplicaciones',
  data () {
    return {
      pendientes: false,
      finalizados: false,
      buscar: null,
      headerPostulaciones: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Código', value: 'codigo' },
        { text: 'Estado', value: 'estado' },
        { text: 'Acciones', value: 'acciones' }
      ],
      i: null,
      indexElegido: null,
      dialog: false,
      eleccion: null,
      postulaciones: {
        dialog: false,
        preview: null,
        todos: []
      },
      comentario: ''
    }
  },
  mounted () {
    // console.log('hola', this.postulaciones.todos)
    // firebase.firestore().collection('postulaciones').get().then(info => {
    //   for (let i = 0; i < info.docs.length; i++) {
    //     this.postulaciones.todos.push(info.docs[i].data())
    //   }
    // })
  },
  computed: {
    ...mapGetters(['getPaises'])
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta']),
    ...mapActions(['enviarCorreo']),
    ver (item) {
      this.i = item
      this.indexElegido = this.postulaciones.todos.indexOf(item)
      this.dialog = true
    },
    async aprobar (index) {
      await firebase.firestore().collection('postulaciones').doc(this.postulaciones.todos[index].codigo).update({ aprobado: true, revisado: true }).then(() => {
        this.enviarCorreo({
          email: 'TrArtist <soycliente@trartist.com>',
          destino: this.postulaciones.todos[index].email,
          // destino: 'danielzemanate@gmail.com',
          asunto: this.$i18n.t('Email.AsuntoAprobado'),
          texto: this.$i18n.t('Email.TextoAprobado', {
            nombre: this.postulaciones.todos[index].nombre,
            codigo: this.postulaciones.todos[index].codigo
          })
        })
        this.postulaciones.todos[index].aprobado = true
        this.dialog = false
      })
        .catch(error => {
          this.setAlerta()
          this.setTextoAlerta(error)
        })
      this.postulaciones.todos = []
      // this.eleccion = 'pendientes'
      if (this.pendientes) {
        await firebase.firestore().collection('postulaciones').where('revisado', '==', false).get().then(info => {
          if (info.docs.length === 0) {
            this.setAlerta()
            this.setTextoAlerta('No hay postulaciones Pendientes')
          }
          for (let i = 0; i < info.docs.length; i++) {
            this.postulaciones.todos.push(info.docs[i].data())
          }
        })
      } else {
        await firebase.firestore().collection('postulaciones').where('revisado', '==', true).get().then(info => {
          for (let i = 0; i < info.docs.length; i++) {
            this.postulaciones.todos.push(info.docs[i].data())
          }
        })
      }
    },
    async rechazar (index) {
      await firebase.firestore().collection('postulaciones').doc(this.postulaciones.todos[index].codigo).update({ aprobado: false, revisado: true }).then(() => {
        this.enviarCorreo({
          email: 'TrArtist <soycliente@trartist.com>',
          destino: this.postulaciones.todos[index].email,
          asunto: this.$i18n.t('Email.AsuntoRechazado'),
          texto: this.$i18n.t('Email.TextoRechazado', {
            nombre: this.postulaciones.todos[index].nombre,
            comentario: this.comentario
          })
        })
        this.postulaciones.todos[index].aprobado = false
        this.dialog = false
      })
      // firebase.firestore().collection('postulaciones').doc(this.postulaciones.todos[index].codigo).delete().then(() => {
      // this.setAlerta()
      // this.setTextoAlerta('Usuario eliminado con éxito')
      // })
        .catch(error => {
          this.setAlerta()
          this.setTextoAlerta(error)
        })
      this.postulaciones.todos = []
      if (this.finalizados) {
        await firebase.firestore().collection('postulaciones').where('revisado', '==', true).get().then(info => {
          for (let i = 0; i < info.docs.length; i++) {
            this.postulaciones.todos.push(info.docs[i].data())
          }
        })
      } else {
        await firebase.firestore().collection('postulaciones').where('revisado', '==', false).get().then(info => {
          if (info.docs.length === 0) {
            this.setAlerta()
            this.setTextoAlerta('No hay postulaciones Pendientes')
          }
          for (let i = 0; i < info.docs.length; i++) {
            this.postulaciones.todos.push(info.docs[i].data())
          }
        })
      }
    },
    imagenGrande (imagen) {
      this.postulaciones.dialog = true
      this.postulaciones.preview = imagen
    }
  },
  watch: {
    eleccion: function (nuevo, anterior) {
      this.postulaciones.todos = []
      if (nuevo === 'pendientes') {
        this.pendientes = true
        this.finalizados = false
        firebase.firestore().collection('postulaciones').where('revisado', '==', false).get().then(info => {
          if (info.docs.length === 0) {
            this.setAlerta()
            this.setTextoAlerta('No hay postulaciones Pendientes')
          }
          for (let i = 0; i < info.docs.length; i++) {
            this.postulaciones.todos.push(info.docs[i].data())
            // console.log('postulaciones', this.postulaciones.todos)
          }
        })
      }
      if (nuevo === 'finalizados') {
        this.pendientes = false
        this.finalizados = true
        firebase.firestore().collection('postulaciones').where('revisado', '==', true).get().then(info => {
          for (let i = 0; i < info.docs.length; i++) {
            this.postulaciones.todos.push(info.docs[i].data())
          }
        })
      }
    }
  }
}
</script>
